import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fixed z-50 w-full max-w-xs flex flex-col items-end bottom-0 right-0 webchat-open mr-3.5",
  style: {"margin-bottom":"21px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Wizard = _resolveComponent("Wizard")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Wizard, {
      onCloseBox: _cache[0] || (_cache[0] = () => _ctx.emit('close-box'))
    })
  ]))
}